export default __webpack_public_path__ + "static/media/video_placeholder.b219b841.png";